export const PROJECT_STATUS = {
  DEPLOYED: "DEPLOYED",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const PROJECT_CATALOG = [
  {
    id: "artfolio",
    titleKey: "title_artfolio",
    descriptionKey: "description_artfolio",
    link: "/projects/artfolio",
    image: "/images/artfolio.png",
    technologies: ["Dart", "Flutter", "Firebase", "Figma"],
    categoryKey: "category_mobile_app",
    status: PROJECT_STATUS.DEPLOYED,
    year: "2024",
    display: [
      "/images/artfolio/getstarted_page.png",
      "/images/artfolio/signin_page.png",
      "/images/artfolio/discover_page.png",
      "/images/artfolio/detailpost_page.png",
      "/images/artfolio/explore_page.png",
      "/images/artfolio/upload_page.png",
      "/images/artfolio/form_page.png",
      "/images/artfolio/yourprofile_page.png",
    ],
  },
  {
    id: "pmr",
    titleKey: "title_pmr",
    descriptionKey: "description_pmr",
    link: "/projects/pmr",
    image: "/images/pmr.png",
    technologies: ["PHP", "JavaScript", "Laravel", "Node.js", "Tailwind CSS", "Figma"],
    categoryKey: "category_web_app",
    status: PROJECT_STATUS.ACTIVE,
    year: "2024",
    display: ["/images/pmr/landing.png", "/images/pmr/signin.png", "/images/pmr/dashboard.png"],
  },
  {
    id: "twodn",
    titleKey: "title_2dn",
    descriptionKey: "description_2dn",
    link: "/projects/twodn",
    image: "/images/2dn.png",
    technologies: ["PHP", "JavaScript", "CSS", "Node.js", "Bootstrap", "Figma"],
    categoryKey: "category_ecommerce",
    status: PROJECT_STATUS.ARCHIVED,
    year: "2023",
    display: ["/images/2dn/demo.gif"],
  },
  {
    id: "etraining",
    titleKey: "title_etraining",
    descriptionKey: "description_etraining",
    link: "/projects/etraining",
    image: "/images/etraining.png",
    technologies: ["PHP", "JavaScript", "Laravel", "Node.js", "Tailwind CSS"],
    categoryKey: "category_lms",
    status: PROJECT_STATUS.DEPLOYED,
    year: "2024",
    display: [
      "/images/etraining/login.png",
      "/images/etraining/tambah.png",
      "/images/etraining/tambah_kompetensi.png",
    ],
  },
];

export const getLocalizedProjects = (translation) => {
  return PROJECT_CATALOG.map((project) => ({
    ...project,
    title: translation[project.titleKey],
    description: translation[project.descriptionKey],
    category: translation[project.categoryKey],
  }));
};

export const getLocalizedProjectById = (id, translation) => {
  const found = PROJECT_CATALOG.find((project) => project.id === id);

  if (!found) {
    return null;
  }

  return {
    ...found,
    title: translation[found.titleKey],
    description: translation[found.descriptionKey],
    category: translation[found.categoryKey],
  };
};
